import Header from "@/components/Header";
import { Footer2 } from "@/components/ui/shadcnblocks-com-footer2";
import PageTransition from "@/components/PageTransition";
import { SEO } from "@/components/SEO";

const Terms = () => {
  return (
    <PageTransition>
      <SEO
        title="תנאי שימוש"
        description="תנאי השימוש באתר אליס תכשיטים ושעונים - מידע על רכישות, משלוחים, זכויות יוצרים, פרטיות ואבטחת מידע"
        canonical="https://alice.jewelry/terms"
        breadcrumbs={[
          { name: 'דף הבית', url: '/' },
          { name: 'תנאי שימוש', url: '/terms' },
        ]}
      />
      <div className="min-h-screen flex flex-col" dir="rtl">
        <Header />
        
        <main className="flex-1">
          <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
              <div className="text-center mb-12 animate-fade-in">
                <div className="gold-divider mb-6" />
                <h1 className="text-4xl md:text-5xl font-serif mb-4">תנאי שימוש</h1>
              </div>

              <div className="space-y-6 text-right animate-fade-in" style={{ animationDelay: '0.1s' }}>
                <div>
                  <h2 className="text-2xl font-serif mb-3">כללי</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    ברוכים הבאים לאתר אליס תכשיטים ושעונים. השימוש באתר זה כפוף לתנאי השימוש המפורטים להלן. 
                    על ידי גלישה באתר ו/או ביצוע רכישה באמצעותו, הנך מאשר כי קראת את תנאי השימוש המפורטים להלן והנך מסכים להם.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">אודות אליס תכשיטים</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    אליס תכשיטים ושעונים, נוסדה בשנת 1984 על ידי הבעלים דוד בורמד ואחיו אלברט בורמד. החנות נקראת על שם אשתו של דוד, אליס בורמד.
                    אליס התחילה עם מכירת שעונים ותכשיטי זהב, ועם השנים גדלה להיות רשת התכשיטים המובילה בדרום.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">רכישה ותשלום</h2>
                  <ul className="space-y-2 text-muted-foreground list-disc list-inside">
                    <li>כל המחירים המופיעים באתר הם במטבע שקל חדש וכולל מע"מ</li>
                    <li>המחירים נכונים למועד פרסומם באתר וייתכנו שינויים ללא הודעה מוקדמת</li>
                    <li>התשלום יתבצע באמצעות כרטיסי אשראי מוכרים או באמצעי תשלום אחרים המוצעים באתר</li>
                    <li>אנו שומרים לעצמנו את הזכות לבטל הזמנה במקרה של טעות במחיר או בתיאור המוצר</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">משלוחים</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    המשלוחים מתבצעים באמצעות חברות שליחויות מוכרות לכל רחבי הארץ. זמן האספקה המשוער הוא 3-7 ימי עסקים מיום ביצוע ההזמנה.
                    עלות המשלוח תופיע במפורש בעמוד התשלום לפני השלמת ההזמנה.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">זכויות יוצרים וקניין רוחני</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    כל התכנים, התמונות, הלוגואים והעיצובים המופיעים באתר הם רכושה של אליס תכשיטים או שותפיה העסקיים ומוגנים בזכויות יוצרים.
                    אין להעתיק, לשכפל, להפיץ או לעשות שימוש מסחרי בתכנים אלו ללא קבלת אישור בכתב מראש.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">פרטיות ואבטחת מידע</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    אנו מחויבים לשמירה על פרטיות המידע האישי שלך. המידע שנאסף באתר ישמש אך ורק למטרות המפורטות במדיניות הפרטיות שלנו.
                    אנו נוקטים באמצעי אבטחה מתקדמים כדי להגן על המידע האישי שלך.
                  </p>
                </div>

                <div className="bg-muted/30 p-6 rounded-lg">
                  <h2 className="text-2xl font-serif mb-3">הגבלת אחריות</h2>
                  <p className="text-muted-foreground leading-relaxed mb-3">
                    אליס תכשיטים לא תהיה אחראית לכל נזק ישיר או עקיף הנובע משימוש באתר או מהסתמכות על המידע המופיע בו.
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    אנו עושים כל מאמץ להציג את המוצרים באופן מדויק ככל האפשר, אך ייתכנו הבדלים קלים בין התמונות המוצגות למוצר הממשי.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">שינויים בתנאי השימוש</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    אליס תכשיטים שומרת לעצמה את הזכות לעדכן ולשנות את תנאי השימוש מעת לעת ללא הודעה מוקדמת.
                    המשך השימוש באתר לאחר ביצוע שינויים מהווה הסכמה לתנאים המעודכנים.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">יצירת קשר</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    לכל שאלה או בירור בנוגע לתנאי השימוש, ניתן לפנות אלינו דרך עמוד צור קשר באתר או באמצעות פרטי ההתקשרות המופיעים בפוטר.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-serif mb-3">סמכות שיפוט</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    על תנאי שימוש אלה יחולו אך ורק דיני מדינת ישראל. סמכות השיפוט הבלעדית תהא לבתי המשפט המוסמכים במחוז הדרום.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer2 />
      </div>
    </PageTransition>
  );
};

export default Terms;
